import { reducer as formReducer } from 'redux-form/immutable';

export default formReducer;
